import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { CurrentAppIdsDto } from 'src/app/core/models/current-app-ids-dto';
import { SessionStorageKeys, StoreService } from './store.service';
import { first, lastValueFrom } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

@Injectable({
    providedIn: 'root'
})
export class UserSessionService {

    constructor(
        private auth: AuthService,
        private http: HttpClient,
        private store: StoreService
    ) {
    }

    async initializeSession(): Promise<void> {
        // Don't start a session until the user is confirmed as logged in
        this.auth.user$
            .pipe(first(user => !!user)) // emits once when user is truthy, then completes
            .subscribe(() => this.init());
    }

    private async init(): Promise<void> {
        let sessionId = this.store.getSession<string>(SessionStorageKeys.SESSION_ID);

        if (!sessionId) {
            sessionId = crypto.randomUUID().toString(); 
            this.store.setSession(SessionStorageKeys.SESSION_ID, sessionId);
        }
        
        console.info(`User Session: ${sessionId} started`);
        
        const appIds = await lastValueFrom(this.http.post<CurrentAppIdsDto>(`${PeriforApiEndpoint}/users/sessions/start`, { sessionId }));
        
        this.store.setSession<CurrentAppIdsDto>(SessionStorageKeys.APP_IDS, appIds);
    }

}
